var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Spaces } from '../../essentials';
import { theme } from '../../essentials/theme';
import { get } from '../../utils/themeGet';
import { getSemanticValue } from '../../utils/cssVariables';
const DEFAULT_ACTIVE_CLASS_NAME = 'active';
const UnderLine = styled.div.withConfig({ displayName: "UnderLine", componentId: "sc-14lsqqg" }) `
    background-color: transparent;
    height: 0.1875rem;
    margin-top: ${Spaces[1]};
`;
const InnerLink = styled.a.attrs({ theme }).withConfig({ displayName: "InnerLink", componentId: "sc-1bxz4gr" }) `
    color: ${getSemanticValue('foreground-neutral-emphasized')};
    cursor: pointer;
    font-size: ${get('fontSizes.1')};
    font-weight: ${get('fontWeights.semibold')};
    font-family: ${get('fonts.normal')};
    margin-right: ${Spaces[3]};
    text-decoration: none;

    &:last-child {
        margin-right: 0;
    }

    &.${props => (props.activeClassName ? props.activeClassName : DEFAULT_ACTIVE_CLASS_NAME)} {
        color: ${getSemanticValue('foreground-accent-default')};

        ${UnderLine} {
            background-color: ${getSemanticValue('foreground-accent-default')};
        }
    }
`;
const Link = (_a) => {
    var { children, selected } = _a, rest = __rest(_a, ["children", "selected"]);
    const combinedClassNames = [rest.className];
    if (selected) {
        combinedClassNames.push(rest.activeClassName ? rest.activeClassName : DEFAULT_ACTIVE_CLASS_NAME);
    }
    return (React.createElement(InnerLink, Object.assign({}, rest, { className: combinedClassNames.join(' ') }),
        children,
        React.createElement(UnderLine, null)));
};
export { Link };
